import React, { useEffect, useState, createElement } from 'react';
// ID real del Meta Pixel
const PIXEL_ID = '286333876857444';
interface MetaPixelProps {
  children?: React.ReactNode;
  debug?: boolean;
}
// Almacena eventos rastreados para depuración
const trackedEvents: {
  event: string;
  params?: any;
  timestamp: Date;
}[] = [];
// Declaración para el objeto fbq global
declare global {
  interface Window {
    fbq: any;
    _fbq?: any;
    fbPixelInitialized?: boolean;
  }
}
const MetaPixel: React.FC<MetaPixelProps> = ({
  children,
  debug = false
}) => {
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    // Evitar inicialización duplicada
    if (window.fbPixelInitialized) {
      setIsInitialized(true);
      return;
    }
    // Implementación estándar del Meta Pixel según la documentación oficial
    const initPixel = () => {
      const fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (window.fbq) return;
      window.fbq = fbq;
      window.fbq.push = fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      // Insertar el script base de Meta Pixel
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Añadir noscript fallback para navegadores sin JavaScript
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      // Insertar elementos en el DOM
      const head = document.head || document.getElementsByTagName('head')[0];
      head.appendChild(script);
      const body = document.body || document.getElementsByTagName('body')[0];
      body.appendChild(noscript);
      // Inicializar el Pixel
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      // Marcar como inicializado
      window.fbPixelInitialized = true;
      setIsInitialized(true);
      console.log('✅ Meta Pixel inicializado correctamente:', PIXEL_ID);
      // Opcional: Registrar evento ViewContent para la página principal
      trackEvent('ViewContent', {
        content_name: 'Corona de Alivio - Landing Page',
        content_category: 'Product Landing',
        content_ids: ['corona_alivio_360'],
        content_type: 'product'
      });
    };
    try {
      initPixel();
    } catch (error) {
      console.error('❌ Error al inicializar Meta Pixel:', error);
    }
    // Mensaje informativo sobre cómo verificar el pixel
    console.info('%c📊 Para verificar el Meta Pixel: instale la extensión "Facebook Pixel Helper" para Chrome', 'background: #4267B2; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
    // Cleanup function
    return () => {
      // No es necesario limpiar el script de Meta Pixel, pero podríamos
      // desactivar el rastreo si fuera necesario
    };
  }, []);
  // Función interna para rastrear eventos
  const trackEvent = (eventName: string, params?: any) => {
    try {
      if (window.fbq) {
        window.fbq('track', eventName, params);
        // Guardar evento para depuración
        trackedEvents.push({
          event: eventName,
          params,
          timestamp: new Date()
        });
        console.log(`✅ Evento rastreado: ${eventName}`, params || '');
      } else {
        console.warn('⚠️ Meta Pixel no está inicializado, no se puede rastrear:', eventName);
      }
    } catch (error) {
      console.error(`❌ Error al rastrear evento ${eventName}:`, error);
    }
  };
  return <>
      {children}
      {debug && process.env.NODE_ENV !== 'production' && <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg border border-gray-200 max-w-sm max-h-96 overflow-auto z-50" data-id="element-317">
          <h3 className="font-bold text-sm mb-2 text-[#4267B2]" data-id="element-318">
            Meta Pixel Debugger
          </h3>
          <div className="text-xs" data-id="element-319">
            <p data-id="element-320">Pixel ID: {PIXEL_ID}</p>
            <p data-id="element-321">
              Estado: {isInitialized ? '✅ Inicializado' : '❌ No inicializado'}
            </p>
            <button onClick={() => window.fbq && window.fbq('track', 'TestEvent')} className="mt-2 bg-[#4267B2] text-white px-2 py-1 rounded text-xs" data-id="element-322">
              Enviar evento de prueba
            </button>
            <h4 className="font-semibold mt-2 mb-1" data-id="element-323">
              Eventos ({trackedEvents.length}):
            </h4>
            <ul className="space-y-1" data-id="element-324">
              {trackedEvents.map((event, index) => <li key={index} className="border-b border-gray-100 pb-1" data-id="element-325">
                  <span className="font-medium" data-id="element-326">{event.event}</span>
                  <span className="text-gray-500 text-[10px] ml-1" data-id="element-327">
                    {event.timestamp.toLocaleTimeString()}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>}
    </>;
};
export default MetaPixel;
// Funciones de seguimiento para usar en otros componentes
export const trackPurchaseClick = (buttonLocation: string, price: number = 25) => {
  try {
    const eventParams = {
      content_name: 'Corona de Alivio 360',
      content_category: 'Product',
      content_ids: ['corona_alivio_360'],
      value: price,
      currency: 'USD',
      button_location: buttonLocation
    };
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', eventParams);
      // Guardar evento para depuración
      trackedEvents.push({
        event: 'InitiateCheckout',
        params: eventParams,
        timestamp: new Date()
      });
      console.log(`✅ Evento rastreado: InitiateCheckout (${buttonLocation})`, eventParams);
    } else {
      console.warn('⚠️ Meta Pixel no está inicializado, no se puede rastrear InitiateCheckout');
    }
  } catch (error) {
    console.error('❌ Error al rastrear clic de compra:', error);
  }
};
export const trackLeadEvent = (source: string) => {
  try {
    const eventParams = {
      content_name: 'Corona de Alivio Interest',
      content_category: 'Product Interest',
      source: source
    };
    if (window.fbq) {
      window.fbq('track', 'Lead', eventParams);
      // Guardar evento para depuración
      trackedEvents.push({
        event: 'Lead',
        params: eventParams,
        timestamp: new Date()
      });
      console.log(`✅ Evento rastreado: Lead (${source})`, eventParams);
    } else {
      console.warn('⚠️ Meta Pixel no está inicializado, no se puede rastrear Lead');
    }
  } catch (error) {
    console.error('❌ Error al rastrear evento lead:', error);
  }
};
export const trackAddToCart = (price: number = 25) => {
  try {
    const eventParams = {
      content_name: 'Corona de Alivio 360',
      content_category: 'Product',
      content_ids: ['corona_alivio_360'],
      value: price,
      currency: 'USD'
    };
    if (window.fbq) {
      window.fbq('track', 'AddToCart', eventParams);
      // Guardar evento para depuración
      trackedEvents.push({
        event: 'AddToCart',
        params: eventParams,
        timestamp: new Date()
      });
      console.log('✅ Evento rastreado: AddToCart', eventParams);
    } else {
      console.warn('⚠️ Meta Pixel no está inicializado, no se puede rastrear AddToCart');
    }
  } catch (error) {
    console.error('❌ Error al rastrear añadir al carrito:', error);
  }
};
export const trackPurchaseComplete = (transactionId: string, price: number = 25, currency: string = 'USD') => {
  try {
    const eventParams = {
      content_name: 'Corona de Alivio 360',
      content_category: 'Product',
      content_ids: ['corona_alivio_360'],
      value: price,
      currency: currency,
      transaction_id: transactionId,
      num_items: 1
    };
    if (window.fbq) {
      window.fbq('track', 'Purchase', eventParams);
      // Guardar evento para depuración
      trackedEvents.push({
        event: 'Purchase',
        params: eventParams,
        timestamp: new Date()
      });
      console.log('✅ Evento rastreado: Purchase', eventParams);
    } else {
      console.warn('⚠️ Meta Pixel no está inicializado, no se puede rastrear Purchase');
    }
  } catch (error) {
    console.error('❌ Error al rastrear compra completada:', error);
  }
};
// Función para obtener todos los eventos rastreados (útil para depuración)
export const getTrackedEvents = () => {
  return [...trackedEvents];
};